<template>
    <div ref="videoBox" class="video-box">
        <div class="video-cover" :style="videoCoverStyleString">
            <video-player ref="videoPlayer"
                          :options="playerOptions" 
                          class="vjs-custom-skin"
                          @ready="playerReadied"
                          @play="onPlayerPlay($event)"
                          @pause="onPlayerPause($event)"
                          @ended="onPlayerEnded($event)"
                          @waiting="onPlayerWaiting($event)"
                          @playing="onPlayerPlaying($event)"
                          @loadeddata="onPlayerLoadeddata($event)"
                          @timeupdate="onPlayerTimeupdate($event)"
                          @canplay="onPlayerCanplay($event)"
                          @canplaythrough="onPlayerCanplaythrough($event)"
                          @statechanged="playerStateChanged($event)"
                          data-setup='{"autoplay":true}'>
            </video-player>
        </div>
        <div class="control-bar" :class="{'hide': hideControlbar}">
            <div class="title">{{ videoTitle }}</div>
            <div v-if="loadType" class="play-button">
                <div :class="isPlaying ? 'player-play' : 'player-pause'" v-text="isPlaying ? '播放中' :'已暂停' "></div>
            </div>
            <span id="played-time" class="time-label">{{ currentTimeString }}</span>
            <div id="progress-box">
                <div id="progress-line" :style="progressLineStyleString"></div>
                <div id="progress-dot" :style="progressDotStyleString"></div>
            </div>
            <span id="duration-time" class="time-label">{{ durationString }}</span>
        </div>
    </div>
</template>

<script>

require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');

import videojs from 'video.js';
import videojsflash from 'videojs-flash';

window.videojs = videojs;

require('videojs-contrib-hls/dist/videojs-contrib-hls.js');

import {videoPlayer} from 'vue-video-player';

export default {
    components: {
        videoPlayer
    },

    props: {
        isLock: {
            type: Boolean,
            default: false
        },
        
        currentShow: {
            type: String,
            default: ''
        },

        hwFilesData: {
            type: Object,
            default: null
        },

        qaFilesData: {
            type: Object,
            default: null
        }
    },
    
    data: function() {
        return {
            loadType: null,
            isPlaying: true,
            fill: true,
            hideControlbar: false,
            videoId: '',
            videoTitle: '',
            currentTimeString: '--:--',
            durationString: '--:--',
            progressLineStyleString: '',
            progressDotStyleString: '',
            videoCoverStyleString: '',
            playerOptions: {
                autoplay: true,
                controls: false,
                bigPlayButton : false,
                // control: {
                //     captionsButton : false,
                //     chaptersButton: false,
                //     subtitlesButton:false,
                //     liveDisplay:false,
                //     playbackRateMenuButton:false
                // },
                html5: {
                    hls: {
                        withCredentials: false,
                        controls: false
                    },
                    controls: false,
                    autoplay: true
                }
            },
            supportedEventNames: ['resource.show', 'files.pause','files.play','common.waiting','files.jump','files.volume'],
        };
    },

    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
    },

    watch:{
        currentShow: function (newVal, oldVal) {
            // the stage is hiding me
            if (newVal !== this.componentId && oldVal === this.componentId) {
                this.player.pause();
                this.player.reset(); // avoid to show the last video while switching to this layer
                this.loadType = null;
            }

            // the stage is showing me
            if (newVal === this.componentId && oldVal !== this.componentId) {
                // this.player.play();
            }
        },

        hwFilesData: function(newVal) {
            if (this.currentShow === 'hw-1') {
                console.log(newVal);
                let data = newVal.data;
                data.id = newVal.data.relationId;
                this.$nextTick(() => {
                    this.showVideoResource(data);
                    this.player.play();
                    this.player.play().catch(err => {
                        console.log(1);
                    });
                });
            }
        },

        qaFilesData: function(newVal) {
            if (this.currentShow === 'qa-1') {
                this.$nextTick(() => {
                    this.showVideoResource(newVal);
                    this.player.play();
                })
            }
        }
    },

    created: function() {
        if (this.currentShow === 'hw-1') {
            console.log(this.hwFilesData);
            let data = this.hwFilesData.data;
            data.id = this.hwFilesData.data.relationId;
            this.$nextTick(() => {
                this.showVideoResource(data);
                this.player.play();
                this.player.play().catch(err => {
                    console.log(1);
                });
            });
        }

        if (this.currentShow === 'qa-1') {
            this.$nextTick(() => {
                this.showVideoResource(this.qaFilesData);
                this.player.play();
            });
        }

    },

    mounted: function() {
        this.componentId = this.$attrs.id;
        window.addEventListener('message', this.windowMessageHandler);
    },

    destroyed: function() {
        window.removeEventListener('message', this.windowMessageHandler);
    },

    

    methods: {
        /**
         * Show the video resource
         */
        showVideoResource(resData) {
            if (! resData || ! resData.url) {
                console.error('invalid video resource to play', resData);
                return;
            }
            console.log('going to play video resource: ', resData.id, resData.name, resData.url);
            this.player.src({
                src: resData.url,
                type: resData.mimeType || 'video/mp4',
                withCredentials: false
            });

            this.videoTitle = resData.name;
            this.videoId = resData.id;
            
            this.player.play().catch(err => {
                console.log('请升级浏览器');
            });

        },


        playerReadied(player) {
            /*
            var hls = player.tech({ IWillNotUseThisInPlugins: true }).hls;
            player.tech_.hls.xhr.beforeRequest = function(options) {
                return options
            };
            */
        },

        onPlayerPlay(player) {
            // console.log(player)
            console.log('the player play event is fired');
            this.hideControlbar = false;
            setTimeout(() => {
                this.hideControlbar = true;
            }, 3000);
            this.isPlaying = true;
            
        },

        onPlayerError(player) {
            console.log('播放错误')
        },

        onPlayerPlaying(player) {
        },

        onPlayerPause(player) {
            this.hideControlbar = false;
            setTimeout(() => {
                this.hideControlbar = true;
            }, 3000);
            this.isPlaying = false;
        },

        onPlayerEnded(player) {
        },

        onPlayerWaiting(player) {
        },
        
        onPlayerLoadeddata(player) {
            this.loadType = this.player.isReady_;
            this.durationString = videojs.formatTime(Math.ceil(player.duration()), 600);
            this.layoutVideo();
            if (this.currentShow === this.componentId) {
                console.log('tell the player to play');
                try {
                    this.player.play();
                } catch (e) {
                    console.log(e);
                }
            } else {
                this.player.pause();
            }
        },

        onPlayerTimeupdate(player) {
            this.currentTimeString = videojs.formatTime(player.currentTime(), 600);
            this.calculateProgress(player);
        },

        onPlayerCanplay(player) {
        },

        onPlayerCanplaythrough(player) {
        },

        playerStateChanged(playerCurrentState) {
        },
        
        layoutUI: function() {
        },

        layoutVideo: function() {
            const vw = this.player.videoWidth();
            const vh = this.player.videoHeight();
            if ( ! vw || ! vh) {
                console.error('can not get the video width and height');
                return;
            }

            const rect = this.$refs.videoBox.getBoundingClientRect();
            let factor = 1.0;
            factor = Math.max(vw / rect.width, vh / rect.height);
            // if (vw <= rect.width && vh <= rect.height) {
            //     // nothing to do
            // } else {
            //     factor = Math.max(vw / rect.width, vh / rect.height);
            // }

            const dw = parseInt(vw / factor);
            const dh = parseInt(vh / factor);

            this.player.width(dw);
            this.player.height(dh);
        },

        calculateProgress(player) {
            const t = player.currentTime();
            const d = player.duration();
            if ( d <= 0) return;

            const dotWidth = 24;
            const barWidth = 400;
            let percent = t / d;
            if (percent > 1) percent = 1;

            this.progressDotStyleString = 'left: ' + ((barWidth - dotWidth) * percent) + 'px';
            this.progressLineStyleString = 'width: ' + (percent * 100) + '%';
        },

        windowMessageHandler: function(e) {
            let msg = e.data;
            if (! msg.eventName) return;
            if (this.supportedEventNames.indexOf(msg.eventName) === -1) return;

            if (!this.isLock && this.currentShow !== this.componentId) return;

            let msgData = msg.data;
            if (msg.eventName == 'resource.show') {
                if (msgData.mimeType === 'application/x-mpegURL' || msgData.mimeType.startsWith('video/')) {
                    // 锁定状态过滤当前显示层
                    if (this.isLock && this.currentShow === this.componentId) return;
                    console.log(this.isLock,this.componentId,this.currentShow);
                    this.showVideoResource(msgData);
                }
            } else if (msg.eventName == 'files.pause') {
                if (!this.isLock && msg.data.id !== this.videoId && this.currentShow !== this.componentId) return;
                if (this.isPlaying) this.player.pause();
            } else if (msg.eventName == 'files.play') {
                if (!this.isLock && msg.data.id !== this.videoId && this.currentShow !== this.componentId) return;
                if (!this.isPlaying) this.player.play();
            } else if (msg.eventName === 'files.jump') {
                if (!this.isLock && msgData.id.toLowerCase() == this.videoId.toLowerCase() && this.currentShow === this.componentId) {
                    console.log('jump')
                    this.hideControlbar = false;
                    setTimeout(() => {
                        this.hideControlbar = true;
                    }, 3000);
                    this.player.currentTime(msgData.jumpTo);
                }
            } else if (msg.eventName === 'files.volume') {
                if (!this.isLock && msgData.id.toLowerCase() == this.videoId.toLowerCase() && this.currentShow === this.componentId) {
                    this.player.volume(msgData.volume);
                }
            } else if (msg.eventName === 'common.waiting') {
                this.player.pause();
            } else {
                return;
            };
        }
    }
};
</script>

<style scoped>
    .video-box {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
    
    .video-cover {
        width: 100%;
        height: 100%;
        padding-bottom: 80px;
        box-sizing: border-box;
        background-color: #252525;
    }
    
    .my-video-player {
        width: 100%;
        height: 100%;
    }

    .control-bar {
        background-color: rgba(0, 0, 0, 0.5);
        height: 60px;
        padding: 10px 40px 10px 40px;
        overflow: hidden;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        transition-duration: 400ms;
        transition-property: opacity;
        opacity: 1.0;
    }

    .control-bar.hide {
        opacity: 0.0;
    }

    .control-bar .title {
        order: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        flex-grow: 1;
        font-size: 1.125rem;
        color: #fff;
        text-align: left;
    }

    .control-bar .play-button {
        margin-left: 20px;
        flex-shrink: 0;
        /* height: 60px;
        width: 60px;
        border-radius: 30px;
        background-image: url('../assets/image/video-play@2x.png');
        background-size: 60px 60px;
        background-repeat: no-repeat; */
    }

    .player-play{
        font-size: 18px;
        color: #FFFFFF;
        padding: 6px;
        background: #4A7FB5;
        border-radius: 4px;
    }
    
    .player-pause{
        font-size: 18px;
        color: #FFFFFF;
        padding: 6px;
        background: #FF6600;
        border-radius: 4px;
    }

    .control-bar .time-label {
        flex-shrink: 0;
        font-size: 1.125rem;
        color: #fff;
        margin-left: 20px;
    }

    .control-bar #progress-box {
        width: 400px;
        height: 2px;
        position: relative;
        flex-shrink: 0;
        background-color: #f1f1f1;
        margin-left: 20px;
    }

    .control-bar #progress-box #progress-line {
        width: 0px;
        height: 2px;
        background-color: #5A9BDC;
    }

    .control-bar #progress-box #progress-dot {
        position: absolute;
        width: 4px;
        height: 4px;
        left: 0px;
        top: -11.5px;
        border: 10px solid #5A9BDC;;
        border-radius: 24px;
        background-color: #f1f1f1;
    }
</style>

<style>
    .video-js {
        background-color: #252525;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
</style>



